import { Typography } from '@leegality/leegality-react-component-library';
import PropTypes from 'prop-types';
import React from 'react';

const FeedbackScreenTitle = ({ title, subtitle }) => (
  <div className="flex flex-col gap-1">
    <Typography
      tag={Typography.Tags.H1}
      variant={Typography.Variants.lg}
      fontWeight={Typography.FontWeight.semibold}
      color={Typography.Colors.gray900}
      className="break-words"
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        tag={Typography.Tags.P}
        variant={Typography.Variants.sm}
        color={Typography.Colors.gray500}
        className="break-words"
      >
        {subtitle}
      </Typography>
    )}
  </div>
);

FeedbackScreenTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

FeedbackScreenTitle.defaultProps = {
  title: '',
  subtitle: '',
};

export default FeedbackScreenTitle;
